import { Injectable } from '@angular/core';
import { hotCallStatus } from '../enums/common.enum';

@Injectable({
  providedIn: 'root'
})
export class HotCallStatusService {

    private data: string;
  constructor() { }

  public getHotCallStatus(status : string) : string {
    return status === hotCallStatus.Open ? 'hot-call-open-top-border' : status === hotCallStatus.Accepted ? 'hot-call-accpted-top-border' :
    status === hotCallStatus.Picked ? 'hot-call-picked-top-border' : status === hotCallStatus.ActionNeeded ? 'hot-call-act-needed-top-border' :
    status === hotCallStatus.PartUnAvailable ? 'hot-call-part-unavable-top-border'  : hotCallStatus.Closed ? 'hot-call-closed-top-border': "";
  }

  setData(data: string): void {
    this.data = data;
  }

  getData(): string {
    return this.data;
  }

  public getHotCallStatusByCode(code: string): string {
    return code === "1" ? 'Open' :
         code === "2" ? 'Accepted' :
         code === "3" ? 'Picked' :
         code === "4" ? 'PO Evaluation' :
         code === "5" ? 'Part Unavailable' :
         code === "6" ? 'Action Needed' :
         code === "7" ? 'Cancelled' :
         code === "8" ? 'Closed' :
         '';
  }
}
